import user from './modules/user'
import common from './modules/common'

export default {
  user,
  common,
}
